import { render, staticRenderFns } from "./RSFileTable.vue?vue&type=template&id=52fe2bee&scoped=true&"
import script from "./RSFileTable.vue?vue&type=script&lang=js&"
export * from "./RSFileTable.vue?vue&type=script&lang=js&"
import style0 from "./RSFileTable.vue?vue&type=style&index=0&id=52fe2bee&lang=scss&scoped=true&"
import style1 from "./RSFileTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fe2bee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52fe2bee')) {
      api.createRecord('52fe2bee', component.options)
    } else {
      api.reload('52fe2bee', component.options)
    }
    module.hot.accept("./RSFileTable.vue?vue&type=template&id=52fe2bee&scoped=true&", function () {
      api.rerender('52fe2bee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/components/repository-selector/RSFileTable.vue"
export default component.exports